import { Box } from '@betterment/samba-react';

import { TextShimmerLoader } from '../../Shared/components/ShimmerLoaders';
import { LegacyCard } from '../../Shared/components-v2/legacy-card/LegacyCard';

const ShimmerLoader = ({ mt = '0' }) => {
  return (
    <Box css={{ marginTop: mt }}>
      <LegacyCard>
        <LegacyCard.Content>
          <TextShimmerLoader numLines={2} />
        </LegacyCard.Content>
      </LegacyCard>
    </Box>
  );
};

export default ShimmerLoader;
